// extracted by mini-css-extract-plugin
export default {"variables":"\"../variables.module.css\"","font-size-middle":"16px","font-golos":"'Golos Text', Arial, sans-serif","button":"Button_button__wiIYs"};